import { CLEAR_PROJECT_ARRAY } from 'root/src/client/logic/header/actionsIds'

export default () => ({
	type: CLEAR_PROJECT_ARRAY,
})
